<template>
  <div
    class="tool_search"
    :class="{'en-tool-search':getLang() === 'en'}"
  >
    <a-form
      layout="inline"
      :form="form"
      @submit="handleSearch"
    >
      <a-form-item :label="`${formName}：`">
        <a-input
          v-decorator="[
            'name',{
              initialValue: filterForm.name
            }
          ]"
          :placeholder="enterPlaceholder"
          @change="onInputChange"
        />
      </a-form-item>
      <!-- v-if="level !== 0" -->
      <a-form-item
        :label="`${developerTitTxt}：`"
        class="developer"
      >
        <a-cascader
          v-decorator="[
            'ids', {
              initialValue: filterForm.ids,
              rules: [{validator: isSelectedUser}]
            }
          ]"
          :options="formatCascader"
          change-on-select
          :show-search="true"
          :placeholder="selectSearchPlace"
          @change="cascaderChange"
        />
      </a-form-item>
      <a-form-item class="tool-search-btn">
        <a-button
          type="primary"
          html-type="submit"
        >
          {{ $t('message["91"]') }}
        </a-button>
        <a-button @click="resetForm">
          {{ $t('message["1625"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapActions, mapMutations } from 'vuex'
import { isSelectedUser } from '../common'
import { getLang } from '@/lib/storage'
export default {
  props: {
    level: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('smart/manage', ['developerList', 'filterForm', 'pagination']),
    ...mapState(['baseinfo']),
    systemRole () {
      const { system_role: systemPermission } = this.baseinfo
      return systemPermission
    },
    formatCascader () {
      return this.perpareCascader(this.developerList)
    },
    formName () {
      return this.$t('message["57"]')
    },
    developerTitTxt () {
      return this.$t('message["549"]')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    selectSearchPlace () {
      return this.$t('message["866"]')
    }
  },
  methods: {
    ...mapActions('smart/manage', ['fetchFormList']),
    ...mapMutations('smart/manage', ['SET_FILTER_FORM']),
    isSelectedUser,
    getLang,
    // 请求数据
    async getFormList (obj = {}) {
      let params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSizesType[this.pagination.pageSize],
        name: this.filterForm.name,
        ...obj
      }
      this.$router.push({ query: params })
      await this.fetchFormList(params)
    },
    // 准备开发人员下拉数据
    perpareCascader (data) {
      let result = []
      if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let obj = {}
          obj.label = item.name
          obj.key = item.keyname + '-' + item.id
          if ('children' in item && item.children.length > 0) {
            obj.key = item.keyname + '-' + item.id
            obj.children = this.perpareCascader(item.children)
          } else {
            obj.key = item.keyname + '-' + item.id
          }
          obj.value = (item.keyname + '-' + item.id).toString()
          result.push(obj)
        }
      }
      return result
    },
    // 选择器改变触发
    cascaderChange (value) {
      if (value.length === 0) {
        // this.clearSelect()
      }
    },
    // 输入框输入改变触发
    onInputChange (e) {
      const { value } = e.target
      this.SET_FILTER_FORM({ name: value })
    },
    // 查询
    handleSearch (e) {
      e.preventDefault()
      const _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          const { name, ids } = values
          let oParam = {}
          ids.forEach(item => {
            let aItem = item.split('-')
            let aItemValue = aItem[1] === '+1' ? '-1' : Number(aItem[1])
            Object.assign(oParam, { [aItem[0]]: aItemValue })
          })
          let params = Object.assign(oParam, { name })
          let { tab, limit, page } = _this.$route.query
          _this.getFormList({
            tab,
            limit,
            page,
            ...params
          })
          _this.$bus.$emit('clearSelectedRowKeys')
        }
      })
    },
    // 重置表单
    resetForm () {
      this.SET_FILTER_FORM({ name: '', ids: [] })
      this.form.resetFields()
      this.getFormList()
      this.$bus.$emit('clearSelectedRowKeys')
    }
  }
}
</script>

<style scoped lang="scss">
.tool_search {
  vertical-align: middle;
  float: right;
  // display: inline-block;
  ::v-deep .ant-form-item-control-wrapper,
  input {
    width: 160px;
  }
  ::v-deep .ant-form-item:last-of-type {
    width: 120px;
    // margin-left: 156px;
  }
  .developer::v-deep {
    margin-right: 184px;
  }
}
.en-tool-search::v-deep {
  margin-right: 22px !important;
  .developer {
    margin-right: 60px;
    .ant-cascader-picker {
      width: 200px !important;
    }
  }
  .tool-search-btn {
    .ant-form-item-control-wrapper {
      width: 170px;
    }
  }
  .ant-form-inline .tool-search-btn {
  }
}
</style>
